/*发薪审核 */
import { $http, buildHeaders } from "./index";

//获取发薪单列表
export const salaryapply_list = (params) => {
  return $http.get("/admin/SalaryApply/index", { params });
};

//获取发薪单详情
export const salaryapply_detail = (id) => {
  return $http.get("/admin/SalaryApply/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取发薪单明细
export const salaryapply_record = (params) => {
  return $http.get("/admin/SalaryApply/detail", {
    params,
    headers: buildHeaders(2),
  });
};

//获取发薪单操作日志
export const salaryapply_log = (params) => {
  return $http.get("/admin/SalaryApply/log", { params });
};

//发薪单审核
export const salaryapply_check = (data) => {
  return $http.post("/admin/SalaryApply/check", data, {
    headers: buildHeaders(3),
  });
};
